import { IConstructorOptions } from "../../../Utilities";
import { BasicEntityWatcher } from "../EntityWatcher";
import quotes from 'quotesy';
import { DataEntityBase } from "./Base/DataEntityBase";
import { Models, IQuote } from "./Base/Models";

export enum DailyEntryProperties {

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // V1 Properties - Cannot Change
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //
    // Base Properties
    //
    date = '_date',

    //
    // Header
    //
    quote = '_quote',

    //
    // Morning
    //
    gratefulIds = '_gratefulIds',
    greatIds = '_greatIds',
    outcomesIds = '_outcomesIds',
    mostImportantTaskIds = '_mostImportantTaskIds',
    score = '_score',

    //
    // Review
    //
    magicMomentsIds = '_magicMomentsIds',
    acomplishmentsIds = '_acomplishmentsIds',
    evenBetterIfIds = '_evenBetterIfIds',
    daysEvents = '_dailyEvents',

    //
    // Looking Forward
    //
    tomorrowsOutcomeIds = '_tomorrowsOutcomeIds',
    anythingImportantIds = '_anythingImportantIds',
    mostImportantTaskTomorrowIds = '_mostImportantTaskTomorrowIds',

    //
    // Execution State
    //
    viewCurentFocus = '_viewCurrentFocus',
    viewSeenQuote = '_viewSeenQuote',


    //
    //
    //
    status = '_status',
}

export enum CurrentDaysFocus {
    Morning = 'Morning',
    Execution = 'Execution',
    Review1 = 'Review1',
    Review2 = 'Review2',
    Complete = 'Complete'
}


export enum EntryScores {
    NotScored,
    Terrible,
    Bad,
    Average,
    Good,
    Amazing,
}

export const CompareFocus = (a: CurrentDaysFocus, b: CurrentDaysFocus) => {

    const focusOrder = [
        CurrentDaysFocus.Morning,
        CurrentDaysFocus.Execution,
        CurrentDaysFocus.Review1,
        CurrentDaysFocus.Review2,
        CurrentDaysFocus.Complete
    ];

    const indexA = focusOrder.indexOf(a);
    const indexB = focusOrder.indexOf(b);
    if (indexA === indexB) {
        return 0;
    }

    if (indexA > indexB) {
        return -1;
    }

    return 1;
}

export class DailyEntry extends DataEntityBase {

    public static get TypeName() { return Models.DailyEntry; }

    public static OptionsFromDate(date: Date) {
        return DataEntityBase.OptionsFromId(DailyEntry.CreateId(DailyEntry.CreateKey(date)));
    }

    public static CreateKey(date: Date) {
        return date.toISOString();
    }

    public static CreateId(key: string) {
        return DataEntityBase.CreateId(DailyEntry.TypeName, key)
    };

    public static Create(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        var retVal = new DailyEntry(options);
        watcher.RegisterEntity(retVal);
        return retVal;
    }

    //
    // Header
    //
    public get date(): Date { return new Date(this.key!); }
    public set date(value: Date) {
        let previous = this.key;
        this.key = value.toISOString();

        if (previous !== this.key)
            this.FireChanged(DailyEntryProperties.date);
    };

    public get quote(): IQuote { return this[DailyEntryProperties.quote]; }
    public set quote(value: IQuote) { this.UpdateAndFire(DailyEntryProperties.quote, value); }
    [DailyEntryProperties.quote] = quotes.random();


    //
    // Morning
    //
    public get gratefulIds(): string[] { return this[DailyEntryProperties.gratefulIds]; }
    public set gratefulIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.gratefulIds, value); }
    [DailyEntryProperties.gratefulIds] = [];

    public get greatIds(): string[] { return this[DailyEntryProperties.greatIds]; }
    public set greatIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.greatIds, value); }
    [DailyEntryProperties.greatIds] = [];

    public get outcomesIds(): string[] { return this[DailyEntryProperties.outcomesIds]; }
    public set outcomesIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.outcomesIds, value); }
    [DailyEntryProperties.outcomesIds] = [];

    public get mostImportantTaskIds(): string[] { return this[DailyEntryProperties.mostImportantTaskIds]; }
    public set mostImportantTaskIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.mostImportantTaskIds, value); }
    [DailyEntryProperties.mostImportantTaskIds] = [];


    //
    // Review
    //
    public get magicMomentsIds(): string[] { return this[DailyEntryProperties.magicMomentsIds]; }
    public set magicMomentsIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.magicMomentsIds, value); }
    [DailyEntryProperties.magicMomentsIds] = [];

    public get acomplishmentsIds(): string[] { return this[DailyEntryProperties.acomplishmentsIds]; }
    public set acomplishmentsIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.acomplishmentsIds, value); }
    [DailyEntryProperties.acomplishmentsIds] = [];

    public get evenBetterIfIds(): string[] { return this[DailyEntryProperties.evenBetterIfIds]; }
    public set evenBetterIfIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.evenBetterIfIds, value); }
    [DailyEntryProperties.evenBetterIfIds] = [];

    public get daysEvents(): string { return this[DailyEntryProperties.daysEvents]; }
    public set daysEvents(value: string) { this.UpdateAndFire(DailyEntryProperties.daysEvents, value); }
    [DailyEntryProperties.daysEvents] = "";

    public get score(): number { return this[DailyEntryProperties.score]; }
    public set score(value: number) {
        this.UpdateAndFire(DailyEntryProperties.score, value);
    }
    [DailyEntryProperties.score] = -1;


    //
    // Looking Forward
    //
    public get tomorrowsOutcomeIds(): string[] { return this[DailyEntryProperties.tomorrowsOutcomeIds]; }
    public set tomorrowsOutcomeIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.tomorrowsOutcomeIds, value); }
    [DailyEntryProperties.tomorrowsOutcomeIds] = [];

    public get anythingImportantIds(): string[] { return this[DailyEntryProperties.anythingImportantIds]; }
    public set anythingImportantIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.anythingImportantIds, value); }
    [DailyEntryProperties.anythingImportantIds] = [];

    public get mostImportantTaskTomorrowIds(): string[] { return this[DailyEntryProperties.mostImportantTaskTomorrowIds]; }
    public set mostImportantTaskTomorrowIds(value: string[]) { this.UpdateAndFire(DailyEntryProperties.mostImportantTaskTomorrowIds, value); }
    [DailyEntryProperties.mostImportantTaskTomorrowIds] = [];


    //
    // Execution State
    //
    public get viewCurentFocus(): CurrentDaysFocus { return this[DailyEntryProperties.viewCurentFocus]; }
    public set viewCurentFocus(value: CurrentDaysFocus) { this.UpdateAndFire(DailyEntryProperties.viewCurentFocus, value); }
    [DailyEntryProperties.viewCurentFocus] = CurrentDaysFocus.Morning;

    public get viewSeenQuote(): boolean { return this[DailyEntryProperties.viewSeenQuote]; }
    public set viewSeenQuote(value: boolean) { this.UpdateAndFire(DailyEntryProperties.viewSeenQuote, value); }
    [DailyEntryProperties.viewSeenQuote] = false;

    public get status(): CurrentDaysFocus { return this[DailyEntryProperties.status]; }
    public set status(value: CurrentDaysFocus) { this.UpdateAndFire(DailyEntryProperties.status, value); }
    [DailyEntryProperties.status] = CurrentDaysFocus.Morning;

    private constructor(options?: IConstructorOptions) {

        super(
            {
                typename: DailyEntry.TypeName,
                serializationProperties: DailyEntryProperties,
                dateProperties: DailyEntry.dateProperties,
                jsonProperties: DailyEntry.jsonProperties
            },);

        this.date = new Date();
        this.CompleteConstruction(options);
    }

    private static dateProperties: string[] = [
        DailyEntryProperties.date
    ];


    private static jsonProperties: string[] = [
        DailyEntryProperties.gratefulIds,
        DailyEntryProperties.greatIds,
        DailyEntryProperties.outcomesIds,
        DailyEntryProperties.mostImportantTaskIds,
        DailyEntryProperties.magicMomentsIds,
        DailyEntryProperties.evenBetterIfIds
    ];
}